'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CSSOM = require('cssom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var CSSOM__default = /*#__PURE__*/_interopDefaultLegacy(CSSOM);

const allowedCSSSelectors = ['.narvar', '#narvar'];
const filterCSSStyleRule = cssText => {
  const {
    selectorText = '',
    style
  } = CSSOM__default["default"].CSSStyleRule.parse(cssText);
  const allowed = allowedCSSSelectors.some(allowedCSSSelector => selectorText.indexOf(allowedCSSSelector) === 0);
  return allowed ? `${selectorText} { ${style.cssText} } ` : '';
};

// Only keep CSS classes that start with one of the allowed css selectors
// to prevent global selectors from being passed
var filterCSSStyles = style => {
  const {
    cssRules
  } = CSSOM__default["default"].parse(style);
  return cssRules.map(cssRule => {
    if (cssRule.type === CSSOM__default["default"].CSSRule.MEDIA_RULE) {
      const {
        cssRules: cssMediaRules = [],
        media
      } = cssRule;
      const filteredMediaStyle = cssMediaRules.map(cssMediaQueryRule => filterCSSStyleRule(cssMediaQueryRule.cssText)).join(' ');
      return filteredMediaStyle ? `@media ${media.mediaText} { ${filteredMediaStyle} } ` : '';
    }
    return filterCSSStyleRule(cssRule.cssText);
  }).join(' ');
};

exports["default"] = filterCSSStyles;
